import 'owl.carousel';

let slider = function ($) {
  $('.owl-carousel').owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    smartSpeed: 500
  });
};
export default slider;



// WEBPACK FOOTER //
// ./app/blocks/slider/slider.js